import { Phrase } from 'components/Phrase';
import { useStringContext } from 'components/StringContext';

import { CircleButtonStyled, Logo, PhoneSvgStyled } from './styles';

export const CarouselItemScheduleMaintenanceExpiredBottom = () => {
  const strings = useStringContext();

  return (
    <>
      <CircleButtonStyled
        icon={<PhoneSvgStyled />}
        label={Phrase({ id: 'SCHEDULE_MAINTENANCE.CALL_US_NOW.LABEL' })}
        onClick={() => (window.location.href = `tel:${strings['PHONE_CLEAN']}`)}
        size="large"
      />
      <Logo />
    </>
  );
};
